import { defineMessages } from 'react-intl';

export default defineMessages({
    SSN: {
        id: 'ml.common.component.MLPayrollDeductComponent.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    EmployeeNumber: {
        id: 'ml.common.component.MLPayrollDeductComponent.Employee Number',
        defaultMessage: 'Employee Number'
    }
});
